<template>
  <div>
    <div class="main">
      <svg-icon icon-class="logo" class="logo"></svg-icon>


      <!--      <svg-icon icon-class="light" style="width:150px;height:43px;margin-left:15px;position: relative;top:0;right: 0"></svg-icon>-->

      <!--      <div :style="light">-->
      <div @click="$openApp" style="right:10px;position:absolute;z-index: 52">
        <svg-icon icon-class="openApp"
                  style="width:73px;height:28px;"></svg-icon>
      </div>

      <!--      </div>-->
      <div style="position: absolute;right: 0;z-index: 51;height: 43px;">
        <svg-icon icon-class="headerBG" style="height: 43px;width: 193px"></svg-icon>
      </div>
    </div>

  </div>


</template>

<script>
export default {
  name: "topBanner",


}
</script>

<style scoped>
.main {
  width: 100%;
  height: 43px;
  /*background-color: #302e28;*/
  background-image: linear-gradient(#2c2a25, #3b3935);
  position: fixed;
  -webkit-user-select: none;
  z-index: 50;
  display: flex;
  align-items: center;
}

.logo {
  width: 131px;
  height: 30px;
  left: 15px;
  position: absolute;

}
</style>
